import {
  LIST_REPORT3,
  LIST_REPORT3_SUCCESS,
  LIST_REPORT3_CLEAN,
  LIST_REPORT3_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  report: [],
}

const Report3List = (state = initialState, action) => {
  switch (action.type) {
    case LIST_REPORT3:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_REPORT3_SUCCESS:
      state = {
        ...state,
        report: action.payload.report,
        loading: false,
        done: true,
      }
      break
    case LIST_REPORT3_CLEAN:
      state = initialState
      break
    case LIST_REPORT3_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default Report3List
